import {
    Directive,
    ElementRef,
    HostListener,
    Renderer2,
    OnInit,
    Input,
  } from '@angular/core';
  
  @Directive({
    selector: '[appDynamicHeight]',
  })
  export class WidthHeightDirective implements OnInit {
    @Input('appDynamicHeight') containerType!: string;
    @Input('moreDetails') moreDetails!: any;
  
    constructor(
      private el: ElementRef,
      private renderer: Renderer2
    ) {
      this.calculateHeight();
    }
    ngOnInit(): void {
      //calculate the height
      this.containerType = this.containerType || 'main';
      this.calculateHeight();
    }
  
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.calculateHeight();
    }
  
    private calculateHeight(): void {
      const screenHeight = window.innerHeight;
      let finalHeight = screenHeight;
      let percent = 100;
  
      if (this.containerType == 'question-block') {
        //const questionCount = this.moreDetails?.questionCount ?? 0;
        finalHeight = screenHeight - 150;
      } else if (this.containerType == 'risk-content-block') {
        finalHeight = screenHeight - 320;
      } else if (this.containerType == 'risk-content-edit-block') {
        const riskCount = this.moreDetails?.riskCount ?? 0;
        percent = 33 * riskCount;
        percent = percent > 65 ? 65 : percent;
        finalHeight = screenHeight * (percent / 100) + 10;
      } else if (this.containerType == 'risk-content-both-block') {
        percent = 25;
        finalHeight = screenHeight * (percent / 100);
      } else if (this.containerType == 'risk-content-summary-edit-block') {
        percent = 25;
        finalHeight = screenHeight * (percent / 100);
      } else if (this.containerType == 'chat-body') {
        const adjustheight = 115;
        finalHeight = screenHeight - adjustheight;
        finalHeight = finalHeight < 200 ? 200 : finalHeight;
      } else if (this.containerType == 'chat-history') {
        finalHeight = 200;
      } else {
        percent = 100;
        finalHeight = screenHeight * (percent / 100);
      }
      this.renderer.setStyle(
        this.el.nativeElement,
        'transition',
        'height 0.9s ease-in-out'
      );
      this.renderer.setStyle(this.el.nativeElement, 'height', `${finalHeight}px`);
    }
  }
  